import { j as o } from "../../jsx-runtime.BREq8dyb.js";
import { faEllipsisV as b, faTimes as f } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as r } from "@fortawesome/react-fontawesome";
import { IconButton as d } from "@mui/joy";
import { Box as g, Menu as C, MenuItem as T, ListItemIcon as k, ListItemText as M } from "@mui/material";
import { memo as q, useState as E, useCallback as p } from "react";
const I = q(({
  menuItems: t,
  MenuButtonProps: u,
  MenuProps: m,
  onClose: l,
  CloseButtonProps: h
}) => {
  const [a, e] = E(null), i = !!a, x = p((n) => {
    n.stopPropagation(), e(n.currentTarget);
  }, [e]), s = p(() => {
    e(null);
  }, [e]);
  return /* @__PURE__ */ o.jsxs(g, { display: "flex", children: [
    t?.length ? /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx(d, { ...u, "aria-controls": i ? "demo-positioned-menu" : void 0, "aria-expanded": i ? "true" : void 0, "aria-haspopup": "true", id: "dq-side-panel-title-toolbar-menu-button", onClick: x, children: /* @__PURE__ */ o.jsx(r, { icon: b }) }),
      /* @__PURE__ */ o.jsx(C, { anchorOrigin: {
        horizontal: "right",
        vertical: "bottom"
      }, onClick: (n) => n.stopPropagation(), transformOrigin: {
        horizontal: "right",
        vertical: "top"
      }, ...m, anchorEl: a, "aria-labelledby": "dq-side-panel-title-toolbar-menu-button", id: "dq-side-panel-title-toolbar-menu", onClose: s, open: i, children: t.map((n, j) => /* @__PURE__ */ o.jsxs(T, { onClick: (c) => n.onClick(s), sx: (c) => n.dangerous ? {
        color: c.palette.error.main
      } : {}, children: [
        n.icon && /* @__PURE__ */ o.jsx(k, { sx: {
          color: "inherit"
        }, children: /* @__PURE__ */ o.jsx(r, { fixedWidth: !0, icon: n.icon }) }),
        /* @__PURE__ */ o.jsx(M, { children: n.label })
      ] }, j)) })
    ] }) : null,
    l && /* @__PURE__ */ o.jsx(d, { ...h, onClick: l, children: /* @__PURE__ */ o.jsx(r, { icon: f }) })
  ] });
});
I.displayName = "DqSidePanelTitleToolbar";
export {
  I as default
};
//# sourceMappingURL=DqSidePanelTitleToolbar.js.map
